export default __webpack_public_path__ + "static/media/001-ahead only.b36dbabc.png";